import HttpClient from "libs/utils/HttpClient";
import qs from "qs";

class ActionService {
  async getRoleList() {
    try {

      const response = await HttpClient.get(`/api/setting/role/list`);
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }


  async getConfigActionList() {
    try {


      const response = await HttpClient.get(`/api/setting/menu/all`);
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async getConfigActionDirectorList({ isCustom } = null) {
    try {

      const params = qs.stringify({
        ...(isCustom && { isCustom }),
      });


      const response = await HttpClient.get(`/api/setting/menu/all?${params}`);
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async addRoleList(body) {
    try {
      const _body = {
        roleAll: body
      };
      const response = await HttpClient.post(`/api/setting/role/add`, _body);
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async addMenu(body) {
    try {
      const response = await HttpClient.post(`/api/setting/menu/add`, body);
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async addSubMenu(body) {
    try {
      const response = await HttpClient.post(`/api/setting/submenu/add`, body);
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async addAction(body) {
    try {
      const response = await HttpClient.post(`/api/setting/actionmenu/add`, body);
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }


  async getActionRoles() {
    try {
      const response = await HttpClient.get(`/api/setting/actions/role`);
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }



  async getActionUser(userId) {
    try {
      const params = qs.stringify({
        ...(userId && { userId }),
      });
      const response = await HttpClient.get(`/api/setting/user/actions/role?${params}`);
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }
  async configActionRoes(body) {

    try {
      const response = await HttpClient.post(`/api/setting/configactionmenu/add`, body);
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async getUserActionsForDirector() {

    try {
      const response = await HttpClient.get(`/api/alluser/actionsuser`);
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async addUserActions(body) {

    try {
      const _body = {
        list: body
      };
      const response = await HttpClient.post(`/api/useractions/add`, _body);
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }


  async getAllActionUser() {

    try {
      const response = await HttpClient.get(`/api/users/actions/select`);
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }





}

export default new ActionService();
